export default __webpack_public_path__ + "static/media/raion-copertina.70e41f6d.jpeg";